/**
 * User toggles for the bhajan view, mirroring the non-admin items in
 * jnana-native's overflow menu (descriptorsCreator.tsx):
 *   - showSvaras         — render svara lines or hide them
 *   - repeatPallavi      — append the pallavi stanza after every caranam
 *   - interpolateSvaras  — copy first-caranam svaras into caranams missing
 *                          svaras. Only meaningful when svaras are shown
 *                          AND repeatPallavi is on (per user spec).
 */

export interface LyricsSettings {
  showSvaras: boolean;
  repeatPallavi: boolean;
  interpolateSvaras: boolean;
}

const KEY = 'bhajan.lyricsSettings.v1';

export const defaultLyricsSettings: LyricsSettings = {
  showSvaras: true,
  repeatPallavi: false,
  interpolateSvaras: false,
};

export function loadLyricsSettings(): LyricsSettings {
  if (typeof window === 'undefined') return defaultLyricsSettings;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return defaultLyricsSettings;
    const parsed = JSON.parse(raw);
    return {
      showSvaras: typeof parsed.showSvaras === 'boolean' ? parsed.showSvaras : defaultLyricsSettings.showSvaras,
      repeatPallavi: typeof parsed.repeatPallavi === 'boolean' ? parsed.repeatPallavi : defaultLyricsSettings.repeatPallavi,
      interpolateSvaras: typeof parsed.interpolateSvaras === 'boolean' ? parsed.interpolateSvaras : defaultLyricsSettings.interpolateSvaras,
    };
  } catch {
    return defaultLyricsSettings;
  }
}

export function saveLyricsSettings(s: LyricsSettings): void {
  try { window.localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* ignore */ }
}
